export default "__VITE_ASSET__8a545ecd__"